import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';

function ihs(f)
{
	return (window.innerHeight * f) + "px";
}



function LuontiMob(p)
{
	return (<div style={{color: "#000000", fontSize: "100%", textAlign: "center"}}>
	<div className="keskitettymob" >
	<h1>{window.LUONTITEKSTIT.ekaosio}</h1>
	</div>
	<div key="gapihmomia" className="otsikkogap"></div>
	<div className="keskitettymob" >
	{window.LUONTITEKSTIT.ekaosioekar}
	</div>
	<div key="gapihmomib" className="paragap"></div>
	<div className="keskitettymob" >
	{window.LUONTITEKSTIT.ekaosiotokar}
	</div>
	<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
	<div className="keskitettymob" style={{fontSize:"50%"}}>
		<img height={ihs(0.25)} src={window.LUONTITEKSTIT.tokaosiokuva} /><br/>
		{window.LUONTITEKSTIT.tokaosiokuvateksti}
	</div>
	<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
		<div className="keskitettymob" style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
			<div style={{fontFamily: "montsB"}}>{window.LUONTITEKSTIT.tokaosioekar}</div>
			<div key="gapihmomid" className="osiogap"></div>
			<div>{window.LUONTITEKSTIT.tokaosiotokar}</div>
			<div key="gapihmomie" className="paragap"></div>
			<div>{window.LUONTITEKSTIT.tokaosiokolmasr}</div>
			<div key="gapihmomif" className="paragap"></div>
			<div>{window.LUONTITEKSTIT.tokaosioneljasr}</div>
		</div>
	</div>
	<div key="gapihmomig" className="osiogap"></div>
	<div className="keskitettymob"><img height={ihs(0.25)} src={window.LUONTITEKSTIT.kolmasosiokuva} /></div>
	<div key="gapihmomig" className="osiogap"></div>
	<div className="keskitettymob" >
	<h1>{window.LUONTITEKSTIT.kolmasosio}</h1>
	</div>
	<div key="gapihmomih" className="otsikkogap"></div>
	<div className="keskitettymob" >
	{window.LUONTITEKSTIT.kolmasosioekar}
	</div>
	<div key="gapihmomii" className="paragap"></div>
	<div className="keskitettymob" >
	{window.LUONTITEKSTIT.kolmasosiotokar}
	</div>
	<div key="gapihmomij" className="osiogap"></div>
	<div key="gapihmomik" className="osiogap"></div>
	<div className="keskitettymob">
		<h3>{window.LUONTITEKSTIT.neljasosio}</h3>
	</div>
	<div key="gapihmomil" className="osiogap"></div>
	<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
		<div className="keskitettymob" style={{display: "inline-block", verticalAlign: "baseline", lineHeight:"1"}}>
			{window.LUONTITEKSTIT.neljasosioekar}
			<div key="gapihmomim" className="paragap"></div>
			{window.LUONTITEKSTIT.neljasosiotokar}
		</div>
	</div>
	<div className="keskitettymob">
		<img height={ihs(0.25)} src={window.LUONTITEKSTIT.neljasosiokuva} />
	</div>

	<div key="gapihmomin" className="osiogap"></div>
	<div className="keskitettyMob" style={{fontSize:"0.5em"}}>
			{window.LUONTITEKSTIT.sivunalateksti}
	</div>
	<div className="keskitettymob" style={{fontSize:"0.5em"}}>
			{window.LUONTITEKSTIT.sivunalatekstivideo}
	</div>

	<div className="seuraavasivumob">
		<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
			<Link to="../kasittely" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKasittelyMob} >
				<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>KÄSITTELY</span>
			</Link>
		</div>
		<div style={{transform: "scale(0.75)"}}>
			<Link to="../kasittely" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKasittelyMob} >
				<ArrowRight stroke="#000000"/>
			</Link>
		</div>
	</div>
		<div key="gapihmomidsiloppu" className="osiogap"></div>
		<div key="gapihmomidsiloppua" className="osiogap"></div>

	</div>);
}
function moveToKasittelyMob()
{
	window.SETKASITTELY();
	window.drawKasittely();
}


export default LuontiMob;
